import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';
import { aiAgentContextType } from '../../aiAgent/store/aiAgent.state';
import { Container } from '../../components/layout/ContainerFlex';
import SidebarContainer, {
  SidebarContainerProps,
} from '../../containers/SidebarContainer';
import ActualityAiAgentConversation from '../../feed/ActualityAiAgentConversation';
import SimulationAiAgentConversation from '../../simulation/SimulationAiAgentConversation';

const SidebarAiAgent: React.FC = props => {
  const contextType = useRecoilValue(aiAgentContextType);

  return (
    <Container
      col
      hasOverflowY
      className={classNames('flex flex-col', 'shadow-xl')}
    >
      {contextType === 'actuality' && <ActualityAiAgentConversation />}
      {contextType === 'simulation' && <SimulationAiAgentConversation />}
    </Container>
  );
};

export default () => {
  const { t } = useTranslation('app');

  const containerProps: SidebarContainerProps = {
    type: 'sidebar-global-ai-agent',
    title: t`Ask AI (Beta)`,
    size: 'half',
    isGlobal: true,
    sideRight: true,
    widthAuto: true,
    // widthAutoOpen: true,
    // behavior: 'push',
  };

  return (
    <SidebarContainer {...containerProps}>
      <SidebarAiAgent />
    </SidebarContainer>
  );
};
